import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_team checks role IN ('manager','employee') with
// status = 'active', excluding the owner. Skip-flag handling delegated to the
// RPC (the skip OR is in the function body — checks both 'team' and 'add_team'
// keys per the skip-key audit).
export async function resolveAddTeamItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_team) return { complete: true, reason: 'team members added' };
  return { complete: false, reason: 'no team members' };
}
